import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedLoadedGeneric): void => {
    if (process.client && import.meta.env.PROD) {
        // @ts-ignore
        ym(94844978, 'hit', to.fullPath);
    }
})
